import { Typography, message, Modal, Form, Upload, Dropdown } from "antd";
import { useEffect, useState } from "react";
import { DeleteOutlined, EditOutlined, PictureOutlined } from "@ant-design/icons";
import { addImagem, deleteImagens, getImagem } from "../../api/imagens";
import { Avatar } from "../avatar";
import { configModal } from "../modalConfig/config";
const { Text } = Typography;

const validator = {
  imagem: [{ required: true, message: "Adicione uma imagem!" }],
};

const HomeImagem = ({ id, loadingComponent }) => {
  const [modal, contextHolder] = Modal.useModal();
  const [loading, setLoading] = useState(false);
  const [imagem, setImagem] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (id > 0) {
      carregar(id);
    }
  }, [id]);

  const carregar = async (id) => {
    if (!id) return;
    setLoading(true);
    try {
      const retorno = await getImagem(id);
      if (retorno?.statusCode === 200) {
        const image = window.URL.createObjectURL(retorno?.response?.data);
        setImagem(image);
      } else {
        setImagem(null);
      }
    } catch (error) {
      message.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  const onSubmit = (formulario) => {
    adicionar(formulario);
  };

  const adicionar = async (formulario) => {
    setLoading(true);

    const formData = new FormData();
    formData.append("imagem", formulario?.imagem?.[0]?.originFileObj ?? "");

    try {
      const retorno = await addImagem(formData);
      if (retorno?.statusCode === 200) {
        message.success("Registro inserido com sucesso!");
        form.resetFields();
        setShowModal(false);
        await carregar(id);
      } else {
        message.error(retorno?.response?.message);
      }
    } catch (error) {
      message.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  const deletar = async (id) => {
    setLoading(true);
    try {
      const retorno = await deleteImagens(id);
      if (retorno?.statusCode === 200) {
        message.success("Registro excluído com sucesso!");
        form.resetFields();
        setShowModal(false);
        setImagem(null);
      } else {
        message.error(retorno?.response?.message);
      }
    } catch (error) {
      message.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  const formFile = (e) => {
    const formato = e?.file?.type === "image/jpeg" || e?.file?.type === "image/png";
    if (!formato) {
      message.error("Selecione uma imagem PNG/JPG!");
      return null;
    }
    const size = e?.file?.size / 1024 / 1024 > 20;
    if (size) {
      message.error("Tamanho não suportado, máximo 20MB!");
      return null;
    }

    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  const modalFormulario = () => {
    return (
      <Modal
        title={
          <Text className="title-middle">
            <EditOutlined /> Editar Foto
          </Text>
        }
        open={showModal}
        onOk={() => form.submit()}
        okText="Salvar"
        width={800}
        okButtonProps={{ size: "large", loading: loading || loadingComponent }}
        cancelButtonProps={{ size: "large", loading: loading || loadingComponent }}
        onCancel={() => {
          setShowModal(false);
          form?.resetFields();
        }}>
        <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
          <Form.Item
            getValueFromEvent={formFile}
            name="imagem"
            label="Foto Perfil"
            valuePropName="fileList"
            hasFeedback
            multiple={false}
            rules={validator?.imagem}>
            <Upload.Dragger
              listType="picture"
              disabled={loading || loadingComponent}
              beforeUpload={() => false}
              accept=".png, .jpg, .jpeg"
              maxCount={1}
              multiple={false}>
              <p className="ant-upload-drag-icon">
                <PictureOutlined />
              </p>
              <p className="ant-upload-text">Adicione aqui uma foto sua (PNG, JPG, JPEG)</p>
              <p className="ant-upload-hint">Clique ou arraste para enviar o arquivo</p>
            </Upload.Dragger>
          </Form.Item>
        </Form>
      </Modal>
    );
  };

  const items = [
    {
      label: "Editar",
      key: "0",
      icon: <EditOutlined />,
      onClick: () => {
        setShowModal(true);
        form.resetFields();
      },
    },
    {
      label: "Excluir",
      danger: true,
      disabled: !imagem,
      icon: <DeleteOutlined />,
      onClick: () =>
        modal.confirm({
          ...configModal,
          title: "Deseja excluir a imagem?",
          onOk() {
            deletar(id);
          },
        }),
      key: "1",
    },
  ];

  return (
    <>
      {modalFormulario()}
      {contextHolder}
      <Dropdown
        destroyPopupOnHide
        menu={{
          items,
        }}
        trigger={["click"]}>
        <a>
          <Avatar image={imagem} />
        </a>
      </Dropdown>
    </>
  );
};

export { HomeImagem };
